import { 
    apiRequest,
    cutiKuotaTahunan
} from '../../../../../../services/adapters/kepegawaian/cutiService'

class DetailRepository {

    fetchKuotaTahunan = async (query) => {
        return await apiRequest("get", cutiKuotaTahunan, {
            params: query
        }, true)
    }
    
}

export default DetailRepository